import React from 'react'
import './card-feature.scss'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
const CardFeature = ({ txt, image }) => {
  return (
    <div className='f-card-feature'>
      <div className='f-card-feature__image'>
        <img src={image.file.url} alt={image.description}/>

      </div>
      <div  className='f-card-feature__txt'>
        {/*{txt}*/}
        {documentToReactComponents(
          JSON.parse(txt.raw)
        )}
      </div>
    </div>
  )
}

export default CardFeature
